import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const zonesService = {
  // List zones with pagination, search, filtering
  list: (queries: QueriesApi) => ApiClient.get(`openstack/dns`, {
    params: {
      ...queries,
    }
  }),

  // Get single zone by ID
  get: (id: string | number) => ApiClient.get(`openstack/dns/${id}`),

  // Create new zone
  create: (data: any) => ApiClient.post(`openstack/dns`, data),

  // Update existing zone
  update: (id: string | number, data: any) => ApiClient.put(`openstack/dns/${id}`, data),

  // Delete zone
  delete: (id: string | number) => ApiClient.delete(`openstack/dns/${id}`),

  // Get create options (regions, types, etc.)
  getCreateOptions: () => ApiClient.get(`openstack/dns/create_options`),

  // List records for a zone
  listRecords: (zoneId: string | number) => ApiClient.get(`openstack/dns/${zoneId}/list_records`),

  // Synchronize recordsets (create/update/delete)
  synchronizeRecords: (zoneId: string | number, data: any) => ApiClient.post(`openstack/dns/${zoneId}/synchronize_records`, data),

  // Get PTR record from IP
  getPtrFromIp: (ip: string, regionName: string) => ApiClient.get(`openstack/dns/get_ptr_from_ip`, {
    params: { ip, region_name: regionName }
  }),

  // Create or update PTR record
  createOrUpdatePtr: (data: any) => ApiClient.post(`openstack/dns/create_or_update_ptr`, data),

  // Set floating IP PTR
  setFloatingIpPtr: (data: any) => ApiClient.post(`openstack/dns/set_floating_ip_ptr`, data),

  // Get floating IP PTR
  getFloatingIpPtr: (floatingIpId: string) => ApiClient.get(`openstack/dns/get_floating_ip_ptr`, {
    params: { floating_ip_id: floatingIpId }
  }),

  // Get price estimation for zone
  getPrice: (email: string, ttl: number, clientId?: string | number) => ApiClient.get(`openstack/dns/get_price`, {
    params: { email, ttl, client_id: clientId }
  }),
};

export default zonesService;
